import { observer } from "mobx-react-lite";
import type { FC, ReactNode } from "react";

import { Card } from "@/components/ui/card";
import { cn } from "@/lib/utils";
import { rootStore } from "@/store/RootStore";

interface FormCardBasicProps {
  children: ReactNode;
  classes?: string;
  isModal?: boolean;
  isDeveloped?: boolean;
}

const MODAL_SIZE = "max-w-[628px]";

const FormCardBasic: FC<FormCardBasicProps> = observer(
  ({ classes, children, isModal, isDeveloped }) => {
    const { isOnboarding } = rootStore.authStore;

    return (
      <div
        className={cn(
          "w-full flex justify-center",
          !isDeveloped && "overflow-x-hidden",
          isOnboarding ? "items-center" : "items-start"
        )}
      >
        <div
          className={cn(
            "w-full flex flex-col rounded-2xl border border-gray-200 border-b-0",
            classes,
            isModal && MODAL_SIZE,
            // TODO: delete isDeveloped after full integration
            isDeveloped && "outline-[#DC2626] outline-2"
          )}
        >
          <Card className={cn("pt-8 pb-0 gap-0")}>{children}</Card>
        </div>
      </div>
    );
  }
);

export default FormCardBasic;
